import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { useLocation } from 'react-router-dom'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import * as notificacionesService from '../servicios/notificacionesService'
import LinkButton from '../ui/LinkButton'
import styles from './DropdownNotificacion.module.css'

const NOTIFICATION_MAX_LENGTH = 35

const DropdownNotificacion = ({ refreshKey }) => {
  const [notificaciones, setNotificaciones] = useState([])
  const [notificacionExistente, setNotificacionExistente] = useState(false)
  const [notificacionLeida, setNotificacionLeida] = useState(0)
  const idUsuarioChat = parseInt(localStorage.getItem('idUsuario'))

  const location = useLocation()

  const fetchNotificaciones = async () => {
    const { data } = await notificacionesService.buscarPorMensaje(idUsuarioChat)
    setNotificaciones(data)
    if (data.length !== 0) {
      setNotificacionLeida(data.filter((n) => n.fechaLeido === null).length)
      setNotificacionExistente(true)
    }
  }
  useEffect(() => {
    fetchNotificaciones()
  }, [location.pathname, refreshKey])

  const handleClickNotificacion = async (idMensaje) => {
    try {
      await notificacionesService.actualizarNotificacion({
        idMensaje: idMensaje
      })
      contador(idMensaje)
    } catch (error) {
      const mensaje = `Ocurrió un error al actualizar la notificación.`
      toastErrorLog(error, mensaje, 'notificacion')
    }
  }

  const obtenerURL = (
    tipoNotificacion,
    idPresupuesto,
    idPublicacion,
    idPedidoItem,
    idVendedor,
    idPedido,
    idComprador
  ) => {
    let path
    switch (tipoNotificacion) {
      case 'PRESUPUESTO':
        path = `/Presupuesto/${idPresupuesto}`
        break

      case 'PUBLICACION':
        path = {
          pathname: `/${idVendedor === idUsuarioChat ? 'PreguntasVendedor' : 'PreguntasComprador'}`,
          state: {
            idPublicacion,
            idVendedor,
            idComprador: idVendedor === idUsuarioChat ? idComprador : null
          }
        }
        break
      case 'COMPRAS':
        path = `/PedidoItem/${idPedidoItem}`
        break
      case 'PEDIDO_CABECERA':
        path = {
          pathname: `/Pedido/${idPedido}`,
          state: { esVentas: false, vieneDeCompras: true }
        }
        break
      case 'PUBLICACION_VENCIDA':
        path = `/Publicaciones/Administrar`
        break
      default:
        path = `/PedidoItem/${idPedidoItem}`
    }
    return path
  }

  const contador = (idMensaje) => {
    const notificacionActualizada = notificaciones.map((n) => {
      return n.idMensaje === idMensaje ? { ...n, fechaLeido: 'leido' } : n
    })

    setNotificaciones(notificacionActualizada)
    setNotificacionLeida(notificacionActualizada.filter((n) => n.fechaLeido === null).length)
    setNotificacionLeida(notificacionActualizada.filter((n) => n.fechaLeido === null).length)
  }

  return (
    <>
      <Dropdown id="drop-mobile-style">
        <Dropdown.Toggle id="drop-toggle-style">
          <div className="btn btn-notificaciones">
            <span
              className={`fa fa-bell ${
                notificacionLeida > 0 ? styles.color_bell_notification : ''
              } mr-1`}
            ></span>
            <span className="badge badge-light">{notificacionLeida}</span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={
            notificacionExistente
              ? styles.dropdown_link_notificacion
              : styles.contenedor_notificaciones_vacias
          }
        >
          {notificacionExistente ? (
            notificaciones.map((notificacion) => (
              <Dropdown.Item
                as={LinkButton}
                to={obtenerURL(
                  notificacion.tipoNotificacion,
                  notificacion.idPresupuesto,
                  notificacion.idPublicacion,
                  notificacion.idPedidoItem,
                  notificacion.idVendedor,
                  notificacion.idPedido,
                  notificacion.idComprador
                )}
                key={notificacion.idMensaje}
                onClick={() =>
                  handleClickNotificacion(notificacion.idMensaje, notificacion.fechaLeido)
                }
                className={`${styles.estilo} ${
                  notificacion.fechaLeido === null
                    ? `fa fa-circle ${styles.circulo}`
                    : styles.circulo_vacio
                }`}
              >
                <div className={styles.notificacion_nueva}>
                  {notificacion.mensajeSistema} en{' '}
                  <b className={styles.titulo_notificacion_publicacion}>{notificacion.titulo}</b>
                  <div className={styles.texto_notificacion}>
                    {notificacion.texto}
                    {notificacion.texto.length === NOTIFICATION_MAX_LENGTH ? '...' : ''}
                  </div>
                </div>
              </Dropdown.Item>
            ))
          ) : (
            <div className="notificaciones-vacias">Aún no tienes notificaciones.</div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

DropdownNotificacion.propTypes = {
  refreshKey: PropTypes.number
}

export default DropdownNotificacion
